import {GETTERS} from './types';
import routes from '../../router';

const getters = {
    [GETTERS.GET_CATALOG](state) {
        return state.catalog;
    },
    [GETTERS.GET_APPLICATIONS](state) {
        return state.catalog?.applications.filter(app => state.consult.applications.includes(app.id));
    },
    [GETTERS.GET_CURRENT_TYPE](state) {
        return state.catalog?.currentTypes.find(currentType => currentType.id === state.consult.currentType);
    },
    [GETTERS.GET_SETPOINT](state) {
        return state.catalog?.setpoints.find(setpoint => setpoint.id === state.consult.setpoint);
    },
    [GETTERS.GET_ROUTE_PARAMS]: (state, getters) => routeName => {
        const routePath = routes.find(route => route.name === routeName).path;
        const matches = routePath.match(/:[^/]+/g) || [];
        const [applications, currentType, setpoint] = matches;

        return {
            ...(applications && { applications: getters[GETTERS.GET_APPLICATIONS].map(app => app.id).join('-') }),
            ...(currentType && { currentType: getters[GETTERS.GET_CURRENT_TYPE]?.slug }),
            ...(setpoint && { setpoint: getters[GETTERS.GET_SETPOINT]?.slug })
        };
    },
    [GETTERS.GET_CONSULT_ID](state){
        return state.consult_id;
    },
    [GETTERS.GET_LOADING](state){
        return state.loading
    },
    [GETTERS.GET_STEPS](state){
        return state.ui.steps;
    },
    [GETTERS.GET_CURRENT_STEP_INDEX](state){
        return state.ui.currentStepIndex;
    },
    [GETTERS.GET_MAX_STEP_INDEX](state){
        return state.ui.maxStepIndex;
    },
    [GETTERS.GET_CONSULT](state){
        return state.consult;
    },
    [GETTERS.GET_VOLTAGE](state){
        return state.consult.voltage;
    },
    [GETTERS.GET_RMS_VOLTAGE](state){
        return state.consult.rmsVoltage;
    },
    [GETTERS.GET_AC_CURRENT](state){
        return state.consult.acCurrent;
    },
    [GETTERS.GET_DC_CURRENT](state){
        return state.consult.dcCurrent;
    },
    [GETTERS.GET_AC_POWER](state){
        return state.consult.acPower;
    },
    [GETTERS.GET_DC_POWER](state){
        return state.consult.dcPower;
    },
    [GETTERS.GET_FREQUENCY](state){
        return state.consult.frequency;
    },
    [GETTERS.GET_PRODUCTS](state){
        return state.products;
    },
};

export default getters;
